module.exports = __webpack_public_path__ + "static/media/ratatool_supplier_fr.cb6b524a.png";